export default __webpack_public_path__ + "static/support-24ef869784a27b4a3645b310977bb8c1.jpg";